// import React from 'react';
import styled from "styled-components";
import infoIcon from "./assets/images/icons/ic_info_blue.svg";
import clockIcon from "./assets/images/icons/ic_clock.svg";
import warningIcon from "./assets/images/icons/ic_warning.svg";
// import warningIcon from "./../assets/images/icons/ic_warning.svg";
import * as Variable from "./CSSVariables";

export const BodyStyle = styled.main`
  h1 {
    font-weight: ${Variable.semiBold};
    // line-height: 80px;
  }
  h2 {
    font-weight: ${Variable.semiBold};
    // line-height: 48px;
  }
  h3 {
    font-weight: ${Variable.semiBold};
    // line-height: 38px;
  }
  h4 {
    font-weight: ${Variable.semiBold};
    // line-height: 34px;
  }
  h5 {
    font-weight: ${Variable.semiBold};
    // line-height: 30px;
  }
  h6 {
    font-weight: ${Variable.semiBold};
    // line-height: 26px;
  }
  @media only screen and (min-width: ${Variable.tablet}) {
    h1 {
      font-weight: ${Variable.semiBold};
      // line-height: 80px;
    }
    h2 {
      font-weight: ${Variable.semiBold};
      // line-height: 70px;
    }
    h3 {
      font-weight: ${Variable.semiBold};
      // line-height: 52px;
    }
    h4 {
      font-weight: ${Variable.semiBold};
      // line-height: 38px;
    }
    h5 {
      font-weight: ${Variable.semiBold};
      // line-height: 26px;
    }
    h6 {
      font-weight: ${Variable.semiBold};
      // line-height: 20px;
    }
  }
  // padding-bottom: 120px;

  .body-section {
    // border-bottom: 1px solid ${Variable.boulder};
    padding: 20px 0;

    input {
      margin-bottom: 12px;
      background-color: ${Variable.mystic};
      border: 0;
    }

    &.body-bag {
      max-width: 1100px;
      margin: 0 auto 60px;
      // input {
      //   margin-bottom: 12px;
      // }
    }
  }

  .section-main {
    min-height: calc(100vh - 240px);
    .container {
      &.main-container {
        .row {
          min-height: calc(100vh - 240px);
          // min-height: 700px;
        }
      }
    }
    .section-main-left {
      @media only screen and (min-width: ${Variable.mobile}) {
        padding-right: 2rem;
      }

      .billing-tab {
        margin-top: 12px;

        .tab-content-wrapper {
          border-bottom: 1px solid ${Variable.alto};
        }
      }
    }
    .section-main-right {
      height: 100%;
      padding: 2rem 0 6rem;
      transition: all 0.1s ease;

      @media only screen and (min-width: ${Variable.mobile}) {
        padding: 3rem 3rem 6rem;
        background-color: ${Variable.mystic};
      }
      @media only screen and (min-width: ${Variable.hdDesktop}) {
        min-height: calc(100vh - 175px);
      }
    }
    .bag-summary-wrapper {
      padding: 0;

      &.error {
        // min-height: calc(100vh - 243px);
        margin-top: 150px;
      }

      @media only screen and (min-width: ${Variable.tablet}) {
        padding-right: 15px;
        padding-left: 15px;
      }
    }
  }
  .link-as-btn {
    text-align: center;
    width: 100%;
    padding: 14px;
    background-color: ${Variable.teal};
    // border: 0;
    border: 1px solid transparent;
    cursor: pointer;
    color: ${Variable.valhalla};
    font-weight: ${Variable.semiBold};
    border-radius: 4px;
    -moz-transition: background-color 0.1s ease;
    transition: background-color 0.1s ease;
    margin: 0 auto 16px;

    &:hover {
      background-color: ${Variable.darkerteal};
    }

    @media only screen and (min-width: ${Variable.desktop}) {
      // margin: 20px auto;
      // max-width: 400px;
      display: block;
      // max-width: 260px;
    }
  }
  .hidden {
    position: absolute;
    left: -10000px;
    top: auto;
    width: 0;
    height: 0;
    overflow: hidden;
  }
  img {
    vertical-align: middle;
  }
  .confirm-payment-form {
    display: none;
    // pointer-events: none;
  }
  &.isKeyboard {
    *,
    button,
    .summary-proceed a.link-as-btn,
    .link-as-btn,
    .bag-preview-wrapper button.show-more,
    .promo-form input,
    .promo-form button,
    button.accordion-view-right,
    .selectInput {
      &:focus {
        // outline: none;
        // border-radius: 4px;
        outline: 3px solid ${Variable.congressBlue};
      }
    }
  }
`;

export const MainBtnStyle = styled.button`
  text-align: center;
  width: 100%;
  padding: 16px;
  background-color: ${Variable.teal};
  border: 0;
  cursor: pointer;
  color: ${Variable.valhalla};
  font-weight: ${Variable.semiBold};
  border-radius: 4px;
  -moz-transition: background-color 0.1s ease;
  transition: background-color 0.1s ease;
  margin: 0 auto 16px;

  &:hover {
    background-color: ${Variable.darkerteal};
  }

  @media only screen and (min-width: ${Variable.desktop}) {
    // margin: 20px auto;
    // max-width: 400px;
    display: block;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const GhostBtnStyle = styled.button`
  text-align: center;
  width: 100%;
  padding: 16px;
  border: 1px solid ${Variable.valhalla};
  background-color: ${Variable.white};
  cursor: pointer;
  color: ${Variable.valhalla};
  font-weight: ${Variable.semiBold};
  border-radius: 4px;
  -moz-transition: background-color 0.1s ease;
  transition: background-color 0.1s ease;
  margin: 0 auto 16px;

  &:hover {
    background-color: #f9f9f9;
  }

  @media only screen and (min-width: ${Variable.desktop}) {
    // margin: 20px auto;
    // max-width: 400px;
    display: block;
  }
`;

export const DesktopContinueShopping = styled.div`
  display: none;

  @media only screen and (min-width: ${Variable.tablet}) {
    display: block;
    margin-bottom: 20px;
  }
`;

export const BodyMainStyle = styled.section`
  position: relative;

  .section-title {
    display: none;
    font-size: 0;
  }

  &.bag-summary-fixed {
    margin-top: 203px;

    @media only screen and (min-width: ${Variable.mobile}) {
      margin-top: 0;
    }

    .loader-wrapper {
      margin-top: -203px;
    }
  }
  &.checkout-summary-fixed {
    .section-main-left {
      @media only screen and (min-width: ${Variable.mobile}) {
        margin-bottom: 100px;
      }
    }
    .section-main-right {
      @media only screen and (min-width: ${Variable.tablet}) {
        position: fixed;
        top: 0;
        max-width: 270px;
        overflow: scroll;
        padding-bottom: 100px;
      }

      @media only screen and (min-width: ${Variable.tabletLandscape}) {
        width: 290px;
        max-width: 290px;
      }
      @media only screen and (min-width: ${Variable.desktop}) {
        max-width: 290px;
      }
      @media only screen and (min-width: ${Variable.mediumDesktop}) {
        // max-width: 418px;
      }
      // @media only screen and (min-width: ${Variable.largeDesktop}) {
      @media only screen and (min-width: 1400px) {
        width: 437px;
        max-width: 437px;
      }
    }
  }
  &.mobile-nav-fixed {
    margin-top: 100px;

    @media only screen and (min-width: ${Variable.mobile}) {
      margin-top: 0;
    }

    .loader-wrapper {
      margin-top: -100px;
    }
  }
  .bag-type-wrapper {
    margin-top: 12px;
    .bag-type {
      font-weight: ${Variable.semiBold};
      font-size: 2rem;
      position: relative;
      padding-left: 2.5rem;

      &:before {
        background-size: contain;
        background-repeat: no-repeat;
        width: 2.2rem;
        height: 2.2rem;
        position: absolute;
        left: 0;
        content: "";
      }

      &.partial {
        color: ${Variable.congressBlue};
        &:before {
          background-image: url("${infoIcon}");
        }
      }
      &.pre-order {
        color: ${Variable.congressBlue};
        &:before {
          background-image: url("${clockIcon}");
        }
      }
      &.unavailable {
        color: ${Variable.milanoRed};
        &:before {
          background-image: url("${warningIcon}");
        }
      }
    }
    .sub-text {
      display: block;
      font-size: 1.6rem;
      margin-top: 8px;
    }
  }
`;

export const SummaryStyle = styled.div`
  &.fixed {
    position: fixed;
    top: 0;
    right: 0;

    @media only screen and (min-width: ${Variable.mobile}) {
      position: static;
    }
  }
`;

export const ModalIconStyle = styled.span`
  // vertical-align: middle;
  background-image: url(${warningIcon});
  background-repeat: no-repeat;
  background-size: contain;
  vertical-align: middle;
  display: inline-block;
  height: 3rem;
  width: 3rem;
  margin-right: 1.6rem;
`;

export const ModalHeadingStyle = styled.span`
  * {
    margin-bottom: 0;
  }
`;

export const AddAddressStyle = styled.button`
  width: 100%;
  background: none;
  text-align: left;
  cursor: pointer;
  border: 1px solid ${Variable.silver};
  border-radius: 8px;
  padding: 12px 18px;
  transition: all 0.1s ease;

  &:hover {
    border: 1px solid ${Variable.congressBlue};

    > p {
      color: ${Variable.congressBlue};
    }
  }
  > p {
    color: ${Variable.scienceBlue};
    margin: 4px 0;
  }
  &.disabled {
    // background-color: #eef1f5;
    // color: gray;
    // pointer-events: none;
    cursor: not-allowed;

    &:hover {
      border: 1px solid ${Variable.silver};
    }

    p {
      color: gray;
    }
  }
`;

export const CustomCheckboxStyle = styled.label`
  display: inline-block;
  position: relative;
  padding-left: 28px;
  margin-bottom: 12px;
  cursor: pointer;
  user-select: none;

  &:hover {
    input {
      ~ .checkmark {
        background-color: ${Variable.mystic};
      }
    }
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked {
      ~ .checkmark {
        background-color: #508df5;
        border: 1px solid #508df5;

        &:after {
          display: block;
        }
      }
    }
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    border: 1px solid ${Variable.silver};

    &:after {
      content: "";
      position: absolute;
      display: none;
      left: 6px;
      top: 2px;
      width: 6px;
      height: 11px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`;

export const AddressItemStyle = styled.div`
  margin-bottom: 12px;
  position: relative;
  border: 0;
  border-radius: 4px;
  position: relative;
  // background-color: ${Variable.mystic};
  label {
    cursor: text;
    position: absolute;
    top: 30%;
    transform: translateY(-50%);
    left: 16px;
    opacity: 0.4;
    transition: all 0.2s ease;
    z-index: 0;
    line-height: initial;
    // left: -10000px;
    // top: auto;
    // width: 1px;
    // height: 1px;
    // overflow: hidden;
  }
  .error {
    // position: absolute;
    bottom: -10px;
    left: 0;
    font-size: 1.2rem;
    color: ${Variable.milanoRed};
    line-height: 0;
  }
  input {
    &[type="text"],
    &[type="email"] {
      background-color: ${Variable.mystic};
      border: 0;

      &.error-field {
        border: 1px solid ${Variable.milanoRed};

        &.hasValue {
          ~ label {
            top: 6px;
          }
          &.focus {
            ~ label {
              top: 6px;
            }
          }
        }

        &:not(.hasValue) {
          &:focus {
            ~ label {
              top: 6px;
            }
          }
        }

        ~ label {
          top: 25%;
        }
      }
    }
    &:focus,
    &.hasValue {
      ~ label {
        cursor: pointer;
        top: 6px;
        left: 9px;
        font-size: 1.2rem;
        transform: none;
      }
    }
  }
  .success-icon {
    position: absolute;
    right: 0;
    top: 30%;
    transform: translateY(-50%);
  }
  a {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const EmptyBagStyle = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  display: block;
  text-align: center;
  width: 100%;
  z-index: 1;

  p {
    font-weight: ${Variable.medium};
    font-size: 2rem;
  }

  &.admin-error {
    width: 40rem;
    h2 {
      font-size: 3rem;
    }
    p {
      font-weight: normal;
    }
  }
`;
